import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import DialogContainer from '../../Inamove/Containers/DialogContainer/DialogContainer'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const V3 = new Video(Config.CINEMATIC_PATH + 'V3' + Config.VIDEO_FILE_EXT)
    CinematicContainer.setVideo(V3)
    LoadingController.addToQueue(V3)

    const exitVideo = new Video(Config.CINEMATIC_PATH + 'V5' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(exitVideo)

    const level = await LevelController.loadLevel('level2')

    await AudioController.addAllToLoadingQueue()

    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    GameSceneContainer.hide()
    InventoryContainer.hide()
    CinematicContainer.show()
    LoadingContainer.hide()
    await CinematicContainer.play()

    CinematicContainer.hide()
    DialogContainer.show()
    LevelController.startLevel('level2')

    CinematicContainer.setVideo(exitVideo)

    // WHY: This is here so we are able to test other Dialogs than D1
    // TODO: revert when test phase is over
    // await level.startDialog('D1')
    await level.startDialog(Object.keys(level.dialogs)[0])

    CinematicContainer.show()
    level.destroy()
    return CinematicContainer.play()
}
